import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { router } from './router';
// import { AuthProvider } from './contexts/AuthContext'; // Import AuthProvider
import './index.css';
import "./i18n";
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';


const stripePublishableKey = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY;
if (!stripePublishableKey) {
  console.error("Stripe publishable key is not set. Please set VITE_STRIPE_PUBLISHABLE_KEY in your .env file.");
}
const stripePromise = stripePublishableKey ? loadStripe(stripePublishableKey) : null;
const queryClient = new QueryClient();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      {/* <AuthProvider>  */}
        {stripePromise ? (
          <Elements stripe={stripePromise}>
            <RouterProvider router={router} />
          </Elements>
        ) : (
          <div>Stripe is not configured. Please check your environment variables. <RouterProvider router={router} /> </div>
          // Fallback: still render the app but without Stripe.
          // Or a more sophisticated error display / blocking UI
        )}
      {/* </AuthProvider> */}
    </QueryClientProvider>
  </StrictMode>
);
